import React from 'react'
import PropTypes from 'prop-types'

import SVG from 'react-inlinesvg'

import Icon from './Icon'

/*

use e.g.:
<Svg src='/images/ios-download.svg' />

CSS:
.parent-class {
  svg {
    fill: green;
  }
}

*/

class Svg extends React.PureComponent {

  render() {

    let srcPth = ''
    let src = this.props.src
    if (process.env.NODE_ENV === 'development' && src.split('/')[0] !== 'https:') {
      srcPth = process.env.REACT_APP_IMG_PATH_DEV
    }

    return (
      <SVG
        cacheRequests={true}
        loader={<Icon icon='spinner' size='2x' spin />}
        src={srcPth + src}
      />
    )

  }
}

Svg.propTypes = {
  src: PropTypes.string.isRequired,
}

export default Svg



// WEBPACK FOOTER //
// ./src/components/shared/elements/Svg.js